import { useSetDocumentTitle } from 'hooks/useSetDocumentTitle';
import { useI18n } from 'i18n/hooks/useI18n';
import { useSearchFacetsVolop } from 'modules/search/constants/useSearchFacetsVolop';
import {
  useSearchFiltersByName,
  useSearchQuery,
} from 'modules/search/contexts/SearchContext';
import { hasDateRange } from 'modules/search/helpers/hasDateRange';
import { SearchPage } from 'modules/search/pages/Search/SearchPage';

export function SearchVolopsPage() {
  const { i18n } = useI18n();

  useSetDocumentTitle(
    /* TRANSLATORS: volop search page title */
    i18n(
      'Best Virtual Volunteer Opportunities, On-Site Volunteering, and More',
    ),
  );
  const filters = useSearchFiltersByName();
  const query = useSearchQuery();

  const { volopSearchFacets } = useSearchFacetsVolop(i18n);

  return (
    <SearchPage
      searchFacets={volopSearchFacets}
      searchType="VOLOP"
      showSortOptions={Boolean(query && !hasDateRange(filters))}
    />
  );
}
